<div class="soft-card p-4 flex flex-col rounded-m">
  <div class="flex flex-row justify-between flex-nowrap center-v mb-2 pb-2 border-bottom">
    <div class="flex flex-col justify-center flex-nowrap">
      <span class="soft-overline color-overline">{{
        bewegung?.beweau?.position
      }}</span>
      <span class="soft-text" [innerHtml]="(bewegung?.beweau?.bezeichnung ?? '') | replace:'\n':'<br />' | secureHtml">
    </span>
  </div>
  <div class="flex gap-3 w-auto items-center justify-end">
    @if (noteEditable) {
      <i
        [ngClass]="(bewegung?.bemerkung?.length ?? 0) > 0 ? 'fa-solid' : 'fa-regular'"
        class="fa-file-alt color-overline cursor-pointer"
        style="font-size: 1.5rem"
        (click)="editNoteTapped?.emit()"
      ></i>
    }
    @if (config?.enablePositionCopy) {
      <i
        class="fa-regular fa-copy color-overline cursor-pointer"
        style="font-size: 1.5rem"
        (click)="copyTapped?.emit(bewegung)"
      ></i>
    }
  </div>
</div>
@if (config.showItemComment && bewegung?.bemerkung) {
  <div
    class="flex flex-col mb-2 pb-2 border-bottom color-light">
    <span class="soft-overline">Vermerk</span>
  <div [innerHTML]="(bewegung?.bemerkung ?? '') | replace:'\n':'<br />' | secureHtml "></div>
</div>
}
@if (bewegung?.mengeEditierbar) {
  <div class="flex flex-row flex-nowrap mt-2">
    @if (!config.hideCurrentAmount) {
      <div class="flex flex-row flex-nowrap center-v">
        <soft-number-input
          [readonly]="true"
          [value]="bewegung?.menge ?? null"
        ></soft-number-input>
        <span class="soft-text" style="min-width: 50px">
          <strong class="ml-2">{{ bewegung?.beweau?.artehErf?.arteh }}</strong>
        </span>
      </div>
    }
    <form class="flex flex-row flex-nowrap center-v" [formGroup]="form">
      <!-- <soft-number-input
      [readonly]="readonly"
      formControlName="mengeErl"
      [placeholder]="'Erledigte Menge'"
    ></soft-number-input> -->
    <input
      type="text"
      formControlName="mengeErl"
      [readonly]="readonly"
      [readOnly]="readonly"
      placeholder="Erledigte Menge"
      inputmode="tel"
      class="soft-input"
      />
    <span class="soft-text" style="min-width: 50px">
      <strong class="ml-2">{{ bewegung?.beweau?.artehErf?.arteh }}</strong>
    </span>
  </form>
</div>
}
</div>
